import React, { Fragment } from "react";

import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getUser } from "./userApi";
import { getAnomalyForPerformerUser } from "../anomalyRegistration/anomalyApi";
import { useNavigate } from "react-router-dom";


export function UserProfile(props) {
  const st = useSelector((state) => state)
  const user = useSelector((state) => state.user)
  const log = useSelector((state) => state.login)
  const dispatch = useDispatch()
  let navigate = useNavigate();


  let info = (<Fragment>
    <div className="text-center"> <span>ФИО</span> </div>
    <div className="row mt-3 row-cols-2">
      <div className="col text-center">
        <i style={{ color: "#212529 !important" }} className="bi bi-person fa-4x fa-user-gear fa-solid"></i>
      </div>
      <div className="col">
        <ul className="px-1 list-group-flush">
          <li className="p-0 list-group-item">ID</li>
          <li className="p-0 list-group-item">Должность</li>
          <li className="p-0 list-group-item">Стаж</li>
        </ul>
      </div>
    </div>
  </Fragment>)

  if (user.username == "" && log.token) {

    dispatch(getUser(log.token))


  } else {




    info = (<Fragment>
      <div className="text-center"> <span>{user.lastName} {user.firstName} {user.patronymic}</span> </div>
      <div className="row mt-3 row-cols-2">
        <div className="col text-center">
          <i style={{ color: "#212529 !important" }} className="bi bi-person fa-4x fa-user-gear fa-solid"></i>
        </div>
        <div className="col">
          <ul className="px-1 list-group-flush">
            <li className="p-0 list-group-item">ID: {user.username}</li>
            <li className="p-0 list-group-item">Должность: {user.post}</li>
            <li className="p-0 list-group-item">Стаж: {user.workExperience}</li>
          </ul>
        </div>
      </div>

    </Fragment>)

  }
  return (
    <Fragment>
      {info}
    </Fragment>
  )

}
